import { useEffect } from "react";
import styles from "./Style.module.css";
import { useLocation } from "react-router-dom";
import { Logo } from "../Logo/Logo";
import { useWebSettings } from "../../Context/WebSettings/WebSettingsContext";

export const SideLayout = () => {
  const { pathname } = useLocation();
  const { 
    headerLogoUrl, 
    backgroundImageUrl, 
    // title, 
    subTitle, 
    description
   } =
    useWebSettings();

  useEffect(() => {
    if (headerLogoUrl) {
      document.documentElement.style.setProperty('--cookiebot-logo-url', `url("${headerLogoUrl}")`);
    }
  }, [headerLogoUrl]);

  if (pathname === "/") return null;

  return (
    <div
      className={styles.sideLayout}
      style={{ "--side-layout-bg-image": `url("${backgroundImageUrl}")` }}
    >
      <div className={styles.content}>
        <Logo src={headerLogoUrl} />
        <div className={styles.top}>
          {/* <h2>{title}</h2> */}
          <h2>Welcome to Natureland</h2>
          <h3>{subTitle}</h3>
        </div>
        <div className={styles.bottom}>
          <h6>{description}</h6>
{/* <h6>
            Experience the perfect spa indulgence here at Natureland. An
            essential escape from the urban demands of a hectic life, our
            plethora of therapeutic body and foot massages are carefully curated
            to balance your mind, body and soul. Natureland offers a serene and
            luxurious retreat for a soulful and rejuvenating experience.
          </h6> */}
          {/* <h6>
            With branches conveniently located within city centres at ION Orchard,
            Valley Point, East Coast, Holland Village, Orchard Point, Orchard Liat
            Towers, Chijmes, Marina Bay Sands, Clarke Quay, Orchard Rendezvous,
            Changi Airport T3, Jewel Changi Airport and Changi Airport T2 to
            provide you with a tranquil retreat from the hustle and bustle of the
            city.
          </h6> */}
        </div>
      </div>
    </div>
  );
};
